import MUIButton from '@/components/MUI-Components/MUI-Button';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import {colors, zIndex} from '@/styles/tokens';
import {nftButtonSx} from '@/styles/nftButtonSx';
import {sectionHeadingSx} from '@/styles/sectionHeading';

const ArrowForwardIcon = dynamic(() => import('@mui/icons-material/ArrowForward'), {ssr: false});

const containerSx = {
    overflow: 'hidden',
    background: `linear-gradient(0deg, rgba(17, 27, 66, 1), rgba(18, 41, 125, 1))`,
    boxShadow: `0px 0px 26px -2.5px rgba(35, 46, 79, 0.05), 0px 2.29px 5.95px -0.67px rgba(35, 46, 79, 0.05), 0px 3.6px 7.57px 3.17px rgba(35, 46, 79, 0.05), inset 0px -1px 2px rgba(255, 255, 255, 0.1)`,
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: '75% 75%',
        opacity: 0.8,
        zIndex: zIndex.base,
        borderRadius: 'inherit'
    }
};

const headingSx = {
    ...sectionHeadingSx,
    background: colors.background.default,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    color: 'transparent'
};

const buttonSx = {textTransform: 'none'};

const buttonsRowSx = {
    display: 'flex',
    flexDirection: {xs: 'column', sm: 'row'},
    gap: 2,
    justifyContent: 'center',
    alignItems: 'center'
};

const HomeLatestCTA = (props: any) => {
    const {heading, subheading, buttonText, meetingLink, openForm, secondaryButtonText, secondaryButtonLink, onSecondaryClick} = props;

    return (
        <Box>
            <MUIContainer>
                <Box
                    position="relative"
                    textAlign="center"
                    color={colors.text.inverse}
                    py={5}
                    borderRadius={7.5}
                    border={3}
                    px={2}
                    sx={containerSx}
                >
                    <Box position="relative" zIndex={1}>
                        <Typography
                            className="font-headers"
                            component="p"
                            fontWeight={600}
                            lineHeight={1.2}
                            maxWidth={{md: '100%', xl: '80%'}}
                            margin="0 auto"
                            sx={headingSx}
                        >
                            {heading}
                        </Typography>
                        <Typography pt={2} pb={4} maxWidth={{md: '60%', xl: '50%'}} margin="0 auto" className="font-regular-text ">
                            {subheading}
                        </Typography>
                        <Box sx={buttonsRowSx}>
                            {meetingLink ? (
                                <Link target="_blank" href={openForm}>
                                    <MUIButton
                                        label={buttonText}
                                        variant="contained"
                                        size="medium"
                                        endIcon={<ArrowForwardIcon />}
                                        disableRipple={true}
                                        className="animated-button moving-icon-button font-headers"
                                        sx={{...buttonSx, ...nftButtonSx}}
                                    />
                                </Link>
                            ) : (
                                <MUIButton
                                    label={buttonText}
                                    variant="contained"
                                    size="medium"
                                    endIcon={<ArrowForwardIcon />}
                                    disableRipple={true}
                                    className="animated-button moving-icon-button font-headers"
                                    sx={{...buttonSx, ...nftButtonSx}}
                                    onClick={openForm}
                                />
                            )}

                            {secondaryButtonText &&
                                (secondaryButtonLink ? (
                                    <Link target="_blank" href={secondaryButtonLink}>
                                        <MUIButton
                                            label={secondaryButtonText}
                                            variant="outlined"
                                            size="medium"
                                            endIcon={<ArrowForwardIcon />}
                                            disableRipple={true}
                                            className="animated-button moving-icon-button transparent-button font-headers"
                                            sx={buttonSx}
                                        />
                                    </Link>
                                ) : (
                                    <MUIButton
                                        label={secondaryButtonText}
                                        variant="outlined"
                                        size="medium"
                                        endIcon={<ArrowForwardIcon />}
                                        disableRipple={true}
                                        className="animated-button moving-icon-button transparent-button font-headers"
                                        sx={buttonSx}
                                        onClick={onSecondaryClick}
                                    />
                                ))}
                        </Box>
                    </Box>
                </Box>
            </MUIContainer>
        </Box>
    );
};

export default memo(HomeLatestCTA);
